// extracted by mini-css-extract-plugin
export default {"container":"hairstyle_container__5C+-H","modelImg":"hairstyle_modelImg__3C2Zs","hairstyleImg":"hairstyle_hairstyleImg__HFTHN","heading":"hairstyle_heading__jvEgS"};